import { JsonObject, JsonProperty } from 'json2typescript';
import { Required } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { CodeTextDiscriminatorModel } from './code-text-discriminator-model';

@JsonObject('KovanHrPayrollCodeTextModel')
export class PayrollCodeTextModel extends CodeTextDiscriminatorModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;
}
